import React, { useState } from 'react';
import "./qualification.css";

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <section className="qualification section">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>

            <div className="qualification-container container">
                <div className="qualification-tabs">
                    <div className={toggleState === 1 ? "qualification-button qualification-active button--flex" : "qualification-button button--flex"} onClick={() => toggleTab(1)}>
                        <i className="uil uil-graduation-cap qualification-icon"></i>Education
                    </div>

                    <div className={toggleState === 2 ? "qualification-button qualification-active button--flex" : "qualification-button button--flex"} onClick={() => toggleTab(2)}>
                        <i className="uil uil-briefcase-alt qualification-icon"></i>Experience
                    </div>

                    <div className={toggleState === 3 ? "qualification-button qualification-active button--flex" : "qualification-button button--flex"} onClick={() => toggleTab(3)}>
                        <i className="uil uil-laptop qualification-icon"></i>Freelance
                    </div>

                    <div className={toggleState === 4 ? "qualification-button qualification-active button--flex" : "qualification-button button--flex"} onClick={() => toggleTab(4)}>
                        <i className="uil uil-heart qualification-icon"></i>Volunteer
                    </div>

                    <div className={toggleState === 5 ? "qualification-button qualification-active button--flex" : "qualification-button button--flex"} onClick={() => toggleTab(5)}>
                        <i className="uil uil-award qualification-icon"></i>Achievement
                    </div>
                </div>

                <div className="qualification-sections">
                    {/* === Tab 1: Education === */}
                    <div className={toggleState === 1 ? "qualification-content qualification-content-active" : "qualification-content"}>
                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Universitas Negeri Surabaya</h3>
                                <span className="qualification-subtitle">D4 Desain Grafis (IPK 3.8 / 4.00)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2024 - Present
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>                            
                            <div>
                                <h3 className="qualification-title">SMAN 1 Talun, Blitar</h3>
                                <span className="qualification-subtitle">MIPA (Eligible) (IPK 90 / 100)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2021 - 2024
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* === Tab 2: Experience === */}
                    <div className={toggleState === 2 ? "qualification-content qualification-content-active" : "qualification-content"}>
                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Dewan Perwakilan Mahasiswa Vokasi</h3>
                                <span className="qualification-subtitle">Commission 4</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> Present
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">Tech A Notes #2</h3>
                                <span className="qualification-subtitle">Production Director (GDG on Campus UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> Present
                                </div>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">GDG on Campus UNESA</h3>
                                <span className="qualification-subtitle">Production Division (Core Team)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> Present
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">Degamon</h3>
                                <span className="qualification-subtitle">Co-Founder & Chief Executive Officer</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> Present
                                </div>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Tech A Notes #1</h3>
                                <span className="qualification-subtitle">Creative Designer (GDG on Campus UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2026
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>
                    </div>

                    {/* === Tab 3: Freelance === */}
                    <div className={toggleState === 3 ? "qualification-content qualification-content-active" : "qualification-content"}>
                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Born To Sweet App</h3>
                                <span className="qualification-subtitle">UI/UX Designer (Pocary Sweet)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2026
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">CV. Langgeng Anugerah Indah</h3>
                                <span className="qualification-subtitle">Brand Identity Designer</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2026
                                </div>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Kawista Made</h3>
                                <span className="qualification-subtitle">UI/UX Designer</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">Barata Madya XII</h3>
                                <span className="qualification-subtitle">UI/UX Designer & Web Developer (SMAN 01 Talun)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2024
                                </div>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Barata Madya XI</h3>
                                <span className="qualification-subtitle">UI/UX Designer & Web Developer (SMAN 01 Talun)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2023
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">PT. Rumah Mesin Kreatif</h3>
                                <span className="qualification-subtitle">UI/UX Designer & Web Developer</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2023
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* === Tab 4: Volunteer === */}
                    <div className={toggleState === 4 ? "qualification-content qualification-content-active" : "qualification-content"}>
                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">PKKMB Vokasi UNESA</h3>
                                <span className="qualification-subtitle">Creative Division (BEM Vokasi UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">Desain Grafis Warehouse Project</h3>
                                <span className="qualification-subtitle">Documentation Division (Himpunan Desain Grafis UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Event Series #4</h3>
                                <span className="qualification-subtitle">Production Division (GDG on Campus UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">Viplay Vokasi Play UNESA</h3>
                                <span className="qualification-subtitle">Information Media Division (BEM Vokasi UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Galasteria 4</h3>
                                <span className="qualification-subtitle">Deputy Chief Executive 2 (Desain Grafis UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">DevFest Surabaya 2025</h3>
                                <span className="qualification-subtitle">Graphic Design Artist (GDG Surabaya)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Sharing is Growing</h3>
                                <span className="qualification-subtitle">UI/UX Designer</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">Galasteria 5</h3>
                                <span className="qualification-subtitle">Deputy Chief Executive (Desain Grafis UNESA)</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> Present
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* === Tab 5: Achievement === */}
                    <div className={toggleState === 5 ? "qualification-content qualification-content-active" : "qualification-content"}>
                        <div className="qualification-data">
                            <div>
                                <h3 className="qualification-title">Best Projects in UI/UX Design Study Jam</h3>
                                <span className="qualification-subtitle">By Google Developer on Campus Universitas Negeri Malang</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                        </div>

                        <div className="qualification-data">
                            <div></div>
                            <div>
                                <span className="qualification-rounder"></span>
                                <span className="qualification-line"></span>
                            </div>
                            <div>
                                <h3 className="qualification-title">Gerak Aktifin (GERAKIN)</h3>
                                <span className="qualification-subtitle">Passed ICASVI funding</span>
                                <div className="qualification-calender">
                                    <i className="uil uil-calendar-alt"></i> 2025
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Qualification;